import { render } from "./ChatUserList.vue?vue&type=template&id=0ab8e842&ts=true"
import script from "./ChatUserList.vue?vue&type=script&lang=ts"
export * from "./ChatUserList.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__